// room_idに紐づく全てのメッセージ情報を取得
export const LIST_ROOM_MESSAGES = `
query listRoomMessages($room_id: String!, $message_limit: Int, $message_next_token: String) {
  listRoomMessages(room_id: $room_id, message_limit: $message_limit, message_next_token: $message_next_token) {
    message_next_token
    messages {
      del_flg
      edit_flg
      file_path
      message
      post_id
      post_sender_id
      reaction
      reaction_source_key
      room_id
      send_datetime
      sort_key
    }
    room_id
  }
}`;
// 新規メッセージ・リアクション投稿
export const POST_MESSAGE = `
mutation postMessage(
  $room_id: String!
  $sort_key: String!
  $post_id: String!
  $post_sender_id: String!
  $send_datetime: String!
  $message: String
  $file_path: String
  $reaction: String
  $reaction_source_key: String
){
  postMessage(
    room_id: $room_id
    sort_key: $sort_key
    post_id: $post_id
    post_sender_id: $post_sender_id
    send_datetime: $send_datetime
    message: $message
    file_path: $file_path
    reaction: $reaction
    reaction_source_key: $reaction_source_key
  ) {
    del_flg
    edit_flg
    file_path
    message
    post_id
    post_sender_id
    reaction
    reaction_source_key
    room_id
    send_datetime
    sort_key
  }
}`;
// メッセージ更新・削除
export const UPDATE_MESSAGE = `
mutation updateMessage(
  $room_id: String!
  $sort_key: String!
  $post_id: String!
  $post_sender_id: String!
  $send_datetime: String!
  $message: String
  $file_path: String
  $reaction: String
  $reaction_source_key: String
  $edit_flg: Boolean
  $del_flg: Boolean
){
  updateMessage(
    room_id: $room_id
    sort_key: $sort_key
    post_id: $post_id
    post_sender_id: $post_sender_id
    send_datetime: $send_datetime
    message: $message
    file_path: $file_path
    reaction: $reaction
    reaction_source_key: $reaction_source_key
    edit_flg: $edit_flg
    del_flg: $del_flg
    ) {
    del_flg
    edit_flg
    file_path
    message
    post_id
    post_sender_id
    reaction
    reaction_source_key
    send_datetime
    room_id
    sort_key
  }
}`;
// メッセージの監視
export const SUBSCRIBE_NEW_MESSAGE = `
subscription subscribeMessage($room_id: String!) {
  subscribeMessage(room_id: $room_id) {
    room_id
    sort_key
    post_id
    post_sender_id
    send_datetime
    message
    file_path
    reaction
    reaction_source_key
    edit_flg
    del_flg
  }
}`;
// 参加時刻監視
export const SUBSCRIBE_USER_ROOM = `
subscription subscribeUserRoom($post_user_id: String!, $room_id: String!) {
  subscribeUserRoom(post_user_id: $post_user_id, room_id: $room_id) {
    last_joined_at
    post_user_id
    send_id
    room_id
  }
}
`;

// ルーム作成
export const CREATE_USER_ROOM = `
mutation createUserRoom(
  $last_joined_at: String!
  $post_user_id: String!
  $room_id: String!
  $send_id: String!
){
  createUserRoom(
    last_joined_at: $last_joined_at
    post_user_id: $post_user_id
    room_id: $room_id
    send_id: $send_id
  ) {
    post_user_id
    last_joined_at
    room_id
    send_id
  }
}
`;

// ルーム参加時刻更新
export const UPDATE_USER_ROOM = `
mutation updateUserRoom(
  $last_joined_at: String!
  $post_user_id: String!
  $room_id: String!
  $send_id: String!
  $organization_id: Int!
){
  updateUserRoom(
    last_joined_at: $last_joined_at
    post_user_id: $post_user_id
    room_id: $room_id
    send_id: $send_id
    organization_id: $organization_id
  ) {
    post_user_id
    last_joined_at
    room_id
    send_id
    organization_id
  }
}
`;

// ルーム参加時刻取得
export const LIST_ROOM_USERS = `
query listRoomUsers($room_id: String!) {
  listRoomUsers(room_id: $room_id) {
    nextToken
    users {
      last_joined_at
      post_user_id
      room_id
      send_id
    }
  }
}`;

// 従業員用：タスク一覧画面 ルーム更新監視
export const SUBSCRIBE_ROOM_LIST_FOR_EMPLOYEE = `
subscription subscribeRoomListForEmployee($send_id: String!) {
  subscribeRoomListForEmployee(send_id: $send_id) {
    post_user_id
    room_id
    last_joined_at
    send_id
    organization_id
  }
}`;

// 組織（企業・健保）用：タスク一覧画面 ルーム更新監視
export const SUBSCRIBE_ROOM_LIST_FOR_ORGANIZATION = `
subscription subscribeRoomListForOrganization($organization_id: Int!) {
  subscribeRoomListForOrganization(organization_id: $organization_id) {
    post_user_id
    room_id
    last_joined_at
    send_id
    organization_id
  }
}`;
